export default class CalendarPrivileges {
    constructor(deletePrivilege = false, editPrivilege = false, approvePrivilege = false) {
        this.setDeletePrivilege(deletePrivilege);
        this.setEditPrivilege(editPrivilege);
        this.setApprovePrivilege(approvePrivilege);
    }

    _convertToBoolean(value) {
        if (typeof value === 'string') {
            return value === '1';
        }
        return Boolean(value);
    }

    setDeletePrivilege(value) {
        this._deletePrivilege = this._convertToBoolean(value);
    }

    getDeletePrivilege() {
        return this._deletePrivilege;
    }

    canDelete() {
        return this._deletePrivilege;
    }

    setEditPrivilege(value) {
        this._editPrivilege = this._convertToBoolean(value);
    }

    getEditPrivilege() {
        return this._editPrivilege;
    }

    canEdit() {
        return this._editPrivilege;
    }

    setApprovePrivilege(value) {
        this._approvePrivilege = this._convertToBoolean(value);
    }

    getApprovePrivilege() {
        return this._approvePrivilege;
    }

    canApprove() {
        return this._approvePrivilege;
    }

    getAllPrivileges() {
        return {
            delete: this._deletePrivilege,
            edit: this._editPrivilege,
            approve: this._approvePrivilege
        };
    }
}
